/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { head, get, filter } from 'lodash' 
import { withRouter } from 'react-router-dom'
import AdminCommonSubscriptions from './AdminCommonSubscriptions'
import { Container } from 'react-bootstrap'
import AdminMainLayout from './AdminMainLayout'
import { adminCustomerSubscriptionFullList } from '../actions/admin_customer_subscription'
import { adminSubscriptionStatusList } from '../actions/admin_subscription_status'
import { adminSavedSearchesSubscriptionList } from '../actions/admin_saved_searches_subscription'
import { AdminQuickLink } from './AdminQuickLink'
import SavedSearches from './SavedSearches'

class AdminSubscriptions extends Component {

    constructor(props) {
        super(props)
        this.state = {// A saved search that has been activated, fed to the filter form. The counter
                      // is used as a key so activating the same search twice reloads the fields.
                      loaded_filter: null,
                      filter_load_count: 0}
    }

    renderCustomerDisplayName = (item) => {

        return (
            <AdminQuickLink name="customer" value={item.customer} label={item.customer_display_name} />
        )

    }

    onActivateSavedSearch = (filters) => {
        const { dispatch } = this.props

        this.setState({loaded_filter: Object.assign({}, filters),
                       filter_load_count: this.state.filter_load_count + 1})

        // updateListFilter merges, so the current filter is cleared first - otherwise values that
        // are in the active filter but not in the saved search would linger.
        dispatch(adminCustomerSubscriptionFullList.clearListFilter())
        dispatch(adminCustomerSubscriptionFullList.updateListFilter(filters))
    }

    render() {
        const that = this
        const { subscription_filter } = this.props
        const { loaded_filter, filter_load_count } = this.state

        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           {name: 'subscriptions', label: 'Subscriptions', url: '/admin/subscriptions'}]}>
              <Container fluid>
                <AdminCommonSubscriptions subscriptionList={adminCustomerSubscriptionFullList}
                                          show_filter={true}
                                          supplementary_headers={{customer_display_name: { name: "Customer", renderValue: that.renderCustomerDisplayName}}}
                                          filter={ loaded_filter }
                                          filter_key={ filter_load_count }
                                          additional_header={( <SavedSearches item_list={adminSavedSearchesSubscriptionList}
                                                                              current_filter={ subscription_filter }
                                                                              onActivate={ that.onActivateSavedSearch } />
                                                            )}
                                          title="Subscriptions" />
              </Container>
            </AdminMainLayout>
        )
    }

}

function mapStateToProps(state, props) {
    return {
        subscription_filter: adminCustomerSubscriptionFullList.getFilter(),
    }
}

export default withRouter(connect(mapStateToProps)(AdminSubscriptions))

const header = css`
display: flex;
justify-content: flex-end;
width: 100%;
`

const price_style = css`
display: flex;
`
